// @flow
import * as React from 'react';
import { withRouter } from 'speed-js-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel';

type SidePanelActionProps = {
    closePanel: (key: string) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    history: Object,
    redirectTo: string,
    resourceName: string,
    resourceArguments?: Array<any>;
    title: string,
    createResource: string,
    onSave: Function,
    onClose: Function,
    match: Object,
    initial?: Object,
    useInitial?: boolean,
    newObjectFormProps?: Object,
    customForm?: React.ComponentType,
    enableReinitialize: boolean,
    saveAndNewOption?: boolean,
}

const MODEL_PAGE_KEY = 'MODEL_PAGE';
const mapDispatchToProps = (dispatch) => (bindActionCreators(
    { closePanel: closePanelAction },
    dispatch,
));

@withRouter
@connect(null, mapDispatchToProps)
class ModelPage extends React.Component<Props> {
    static defaultProps: Object;

    addingNew: boolean = false;

    handleClose = () => {
        const {
            history, redirectTo, onClose, closePanel,
        } = this.props;
        history.push(redirectTo);
        closePanel(MODEL_PAGE_KEY);
        if (onClose) {
            onClose();
        }
    };

    handleSubmit = () => {
        const { onSuccess, onSave } = this.props;
        if (onSuccess) {
            onSuccess();
        }
        if (onSave) {
            onSave();
        }
        if (!this.addingNew) {
            this.handleClose();
        }
        this.addingNew = false;
    }

    handleSubmitAndNew = () => {
        this.addingNew = true;
    }

    render() {
        const {
            resourceName, resourceArguments, title, createResource, initial, useInitial, newObjectFormProps,
            customForm: CustomForm, enableReinitialize, saveAndNewOption,
        } = this.props;

        // eslint-disable-next-line
        const objectId = this.props.match.params.id;
        return (
            <SidePane
                id={MODEL_PAGE_KEY}
                openInitially
                closeAllOpened
                key={objectId}
                title={title}
                onClose={this.handleClose}
            >
                {CustomForm ? (
                    <CustomForm
                        {...this.props}
                        resourceName={createResource || resourceName}
                        resourceArguments={resourceArguments}
                        objectId={objectId}
                        onSuccess={this.handleSubmit}
                        onClose={this.handleClose}
                        initial={initial}
                        useInitial={useInitial}
                        enableReinitialize={enableReinitialize === 'undefined' ? true : enableReinitialize}
                        {...newObjectFormProps}
                    />
                ) : (
                    <ApiForm
                        {...this.props}
                        resourceName={createResource || resourceName}
                        resourceArguments={resourceArguments}
                        objectId={objectId}
                        onSuccess={this.handleSubmit}
                        onClose={this.handleClose}
                        initial={initial}
                        useInitial={useInitial}
                        enableReinitialize={enableReinitialize === 'undefined' ? true : enableReinitialize}
                        height="100%"
                        handleSubmitAndNew={saveAndNewOption && this.handleSubmitAndNew}
                        {...newObjectFormProps}
                    />
                )}
            </SidePane>
        );
    }
}

ModelPage.defaultProps = {
    redirectTo: '/',
    onSave: null,
    onClose: null,
    resourceArguments: [],
    initial: null,
    useInitial: true,
    newObjectFormProps: {},
    customForm: null,
    saveAndNewOption: false,
};


export default ModelPage;
